import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class GeoLocationService {
  public location: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public locationOnce: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public error = null;
  constructor() {
  }

  private watchNumber: number;

  public startWatching() {
    if (window.navigator && window.navigator.geolocation) {
      this.watchNumber = window.navigator.geolocation.watchPosition(
          (position) => {
              this.error = null;
            this.location.next(position);
            console.log('Current location', position);
          },
          (error) => {
            // sending error will terminate the stream
            this.location.next(null);
            this.error = error.code;
          },
          {
            enableHighAccuracy: true,
            timeout: 5000
          });
    }
  }


  private stopWatching() {
      window.navigator.geolocation.clearWatch(this.watchNumber);
      this.watchNumber = -1;
  }
}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/services/geo-location.service.ts